import { ClassNameProps, ModalProps } from '@/Types';
import React, { useMemo } from 'react';
import styles from './SynchModal.scss';
import { useLocalization, useTabs } from '@/Hooks';
import { Modal } from '@/Components/Modal/Modal';
import { Tabs } from '@/Components/Tabs/Tabs';
import { TabList } from '@/Components/Tabs/modules/TabList/TabList';
import { TabItem } from '@/Components/Tabs/modules/TabItem/TabItem';
import { TabsPanel } from '@/Components/Tabs/modules/TabPanel/TabPanel';
import { UpdateByFile } from './modules/UpdateFromFile/UpdateByFile';
import { Logistic } from './modules/Logistic/Logistic';
import { Marketplace } from './modules/Marketplace/Marketplace';

type Props = ModalProps & ClassNameProps;

export function SynchModal({ closeModalWindow }: Props) {
  const {
    modalWindows: {
      mpSynchronization: { ModalTabs },
    },
  } = useLocalization();

  const { setActiveTab, isActive } = useTabs(0);

  const tabs = useMemo(() => {
    return [ModalTabs.Marketplace, ModalTabs.Logistic, ModalTabs.UpdateByFile];
  }, [ModalTabs]);

  return (
    <Modal modalClassName={styles.modal} onClose={closeModalWindow}>
      <Tabs>
        <TabList>
          {tabs.map((tabName, idx) => (
            <TabItem
              className={styles.tabItem}
              idx={idx}
              tabName={tabName.title}
              key={tabName.title}
              isActive={isActive(idx)}
              onClick={(idx) => {
                setActiveTab(idx);
              }}
            />
          ))}
        </TabList>

        <TabsPanel isActive={isActive(0)}>
          <Marketplace closeModalWindow={closeModalWindow} />
        </TabsPanel>

        <TabsPanel isActive={isActive(1)}>
          <Logistic closeModalWindow={closeModalWindow} />
        </TabsPanel>

        <TabsPanel isActive={isActive(2)}>
          <UpdateByFile closeModalWindow={closeModalWindow} />
        </TabsPanel>
      </Tabs>
    </Modal>
  );
}
